define([
    'text!product-detail/component/scene-list.html',
    'product-detail/mixin/product',

    'css!product-detail/component/scene-list.css'
], function(
    tpl,
    ProductMixin
){
    return {
        template: tpl,
        mixins: [ProductMixin],
        computed: {
            scenes: function(){
                return this.spuExtraBase.sceneData || [];
            },
            isRender: function(){
                return this.moduleConfig.scene && this.scenes.length;
            }
        },
        methods: {
            getImageWidth: function(type){
                switch(parseInt(type)){
                    case 1:
                        return '100%';
                    case 2:
                        return '80%';
                    default:
                        return '100%';
                }
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/scene-list.js
// module id = 330
// module chunks = 0